module.exports = __webpack_public_path__ + "img/052-kosovo.3e793eab.svg";